var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sticky top-0 left-0 bl-header",
      style: { zIndex: 100 },
      attrs: { id: "blum-header" }
    },
    [
      _c(
        "nav",
        { staticClass: "bl-header-nav" },
        [
          _vm.currentUser.id
            ? _c(
                "router-link",
                {
                  staticClass: "flex items-center text-2xl font-bold font-logo",
                  attrs: {
                    to: _vm.currentUserRole.includes("admin")
                      ? "/team"
                      : "/clients"
                  }
                },
                [_vm._v("\n      Blüm\n    ")]
              )
            : _c(
                "div",
                {
                  staticClass: "flex items-center text-2xl font-bold font-logo"
                },
                [_vm._v("\n      Blüm\n    ")]
              ),
          _vm._v(" "),
          _vm.currentUser.id
            ? _c(
                "div",
                {
                  staticClass:
                    "flex items-center justify-end flex-grow w-full lg:justify-between"
                },
                [
                  _c(
                    "div",
                    { staticClass: "hidden gap-6 lg:flex top-navigation" },
                    [
                      _vm.currentUserRole.includes("admin")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "relative transition-all duration-300 cursor-pointer",
                              class: {
                                "router-link-active": _vm.isCenterActive
                              },
                              on: {
                                click: function($event) {
                                  _vm.centerMenuOpened = true
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flex items-center gap-2" },
                                [
                                  _c("BlTextSubtitle2", {
                                    attrs: { text: "Center" }
                                  }),
                                  _vm._v(" "),
                                  _c("BlIcon", {
                                    staticClass:
                                      "w-5 h-5 transition-all duration-300",
                                    style: {
                                      rotate: _vm.centerMenuOpened
                                        ? "180deg"
                                        : ""
                                    },
                                    attrs: { icon: "chevron-down" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.centerMenuOpened
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "absolute flex flex-col flex-shrink-0 w-full gap-1 px-2 py-2 mt-3 overflow-y-auto border rounded shadow-md min-w-48 bg-pure-white border-grey-200"
                                    },
                                    _vm._l(_vm.centerMenu, function(item, idx) {
                                      return _c(
                                        "div",
                                        { key: idx },
                                        [
                                          item.divider
                                            ? _c("div", {
                                                staticClass:
                                                  "w-full h-px bg-slate-400"
                                              })
                                            : _c(
                                                "router-link",
                                                {
                                                  staticClass:
                                                    "flex items-center flex-shrink-0 w-full gap-3 px-2 py-2 truncate transition-all duration-300 rounded cursor-pointer",
                                                  class: [
                                                    item.isActive
                                                      ? "bg-slate-300"
                                                      : "hover:bg-hover-state"
                                                  ],
                                                  attrs: {
                                                    to: item.target,
                                                    title: item.label
                                                  }
                                                },
                                                [
                                                  _c("BlTextSubtitle3", {
                                                    staticClass:
                                                      "flex-shrink-0 truncate",
                                                    attrs: { text: item.label }
                                                  })
                                                ],
                                                1
                                              )
                                        ],
                                        1
                                      )
                                    }),
                                    0
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.currentUserRole.includes("admin") &&
                      _vm.enableAppointment
                        ? _c(
                            "router-link",
                            {
                              staticClass:
                                "relative transition-all duration-300",
                              attrs: { to: "/appointments" }
                            },
                            [
                              _c("BlTextSubtitle2", {
                                attrs: { text: "Appointments" }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentUserRole.includes("admin") &&
                      _vm.enableSalesPipeline
                        ? _c(
                            "router-link",
                            {
                              staticClass:
                                "relative transition-all duration-300",
                              attrs: { to: "/client-acquisition" }
                            },
                            [
                              _c("BlTextSubtitle2", {
                                attrs: { text: "Client Acquisition" }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          staticClass: "relative transition-all duration-300",
                          attrs: { to: "/my-sessions" }
                        },
                        [
                          _c("BlTextSubtitle2", {
                            attrs: { text: "My Sessions" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          staticClass: "relative transition-all duration-300",
                          attrs: { to: "/clients" }
                        },
                        [_c("BlTextSubtitle2", { attrs: { text: "Clients" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "relative transition-all duration-300 cursor-pointer",
                          class: {
                            "router-link-active": _vm.isRepositoryActive
                          },
                          on: {
                            click: function($event) {
                              _vm.repositoryMenuOpened = true
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex items-center gap-2" },
                            [
                              _c("BlTextSubtitle2", {
                                attrs: { text: "Repository" }
                              }),
                              _vm._v(" "),
                              _c("BlIcon", {
                                staticClass:
                                  "w-5 h-5 transition-all duration-300",
                                style: {
                                  rotate: _vm.repositoryMenuOpened
                                    ? "180deg"
                                    : ""
                                },
                                attrs: { icon: "chevron-down" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.repositoryMenuOpened
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "absolute flex flex-col flex-shrink-0 w-full gap-1 px-2 py-2 mt-3 overflow-y-auto border rounded shadow-md min-w-48 bg-pure-white border-grey-200"
                                },
                                _vm._l(_vm.repositoryMenu, function(item, idx) {
                                  return _c(
                                    "div",
                                    { key: idx },
                                    [
                                      item.divider
                                        ? _c("div", {
                                            staticClass:
                                              "w-full h-px bg-slate-400"
                                          })
                                        : _c(
                                            "router-link",
                                            {
                                              staticClass:
                                                "flex items-center flex-shrink-0 w-full gap-3 px-2 py-2 truncate transition-all duration-300 rounded cursor-pointer",
                                              class: [
                                                item.isActive
                                                  ? "bg-slate-300"
                                                  : "hover:bg-hover-state"
                                              ],
                                              attrs: {
                                                to: item.target,
                                                title: item.label
                                              }
                                            },
                                            [
                                              _c("BlTextSubtitle3", {
                                                staticClass:
                                                  "flex-shrink-0 truncate",
                                                attrs: { text: item.label }
                                              })
                                            ],
                                            1
                                          )
                                    ],
                                    1
                                  )
                                }),
                                0
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "relative" }, [
                    _c(
                      "div",
                      {
                        staticClass: "cursor-pointer",
                        on: {
                          click: function($event) {
                            _vm.profileMenuOpened = true
                          }
                        }
                      },
                      [
                        _c("Avatar", {
                          staticClass:
                            "transition-all duration-300 bg-red-salmon hover:bg-error-400",
                          attrs: { name: _vm.currentUser.name }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.profileMenuOpened
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "absolute right-0 flex flex-col flex-shrink-0 w-full gap-1 px-2 py-2 mt-3 overflow-y-auto border rounded shadow-md min-w-64 bg-pure-white border-grey-200"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "flex flex-col px-2 py-3 rounded",
                                class: {
                                  "bl-profile-admin":
                                    _vm.currentUserRole === "admin",
                                  "bl-profile-staff":
                                    _vm.currentUserRole === "staff",
                                  "bl-profile-super-admin":
                                    _vm.currentUserRole === "super_admin"
                                }
                              },
                              [
                                _c("BlTextSubtitle3", {
                                  class: {
                                    "text-cornflower-700":
                                      _vm.currentUserRole === "admin",
                                    "text-lime-700":
                                      _vm.currentUserRole === "staff",
                                    "text-orange-700":
                                      _vm.currentUserRole === "super_admin"
                                  },
                                  attrs: { text: _vm.currentUser.name }
                                }),
                                _vm._v(" "),
                                _c("BlTextBody3", {
                                  class: {
                                    "text-cornflower-700":
                                      _vm.currentUserRole === "admin",
                                    "text-lime-700":
                                      _vm.currentUserRole === "staff",
                                    "text-orange-700":
                                      _vm.currentUserRole === "super_admin"
                                  },
                                  attrs: { text: _vm.currentUser.email }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "flex items-center gap-1 mt-1"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex items-center h-6 px-2",
                                        class: {
                                          "bg-cornflower-700":
                                            _vm.currentUserRole === "admin",
                                          "bg-lime-700":
                                            _vm.currentUserRole === "staff",
                                          "bg-orange-700":
                                            _vm.currentUserRole ===
                                            "super_admin"
                                        }
                                      },
                                      [
                                        _c("BlTextBody3", {
                                          staticClass: "text-pure-white",
                                          attrs: {
                                            text:
                                              _vm.userRoles[_vm.currentUserRole]
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.currentUser.is_owner
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex items-center h-6 px-2 bg-dark-purple-100"
                                          },
                                          [
                                            _c("BlTextBody3", {
                                              staticClass: "text-pure-white",
                                              attrs: { text: "Owner" }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.profileMenu, function(item, idx) {
                              return _c(
                                "div",
                                { key: idx },
                                [
                                  item.divider
                                    ? _c("div", {
                                        staticClass: "w-full h-px bg-slate-400"
                                      })
                                    : _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "flex items-center flex-shrink-0 w-full gap-3 px-2 py-2 truncate transition-all duration-300 rounded cursor-pointer",
                                          class: [
                                            item.isActive
                                              ? "bg-slate-300"
                                              : "hover:bg-hover-state"
                                          ],
                                          attrs: {
                                            to: item.target,
                                            title: item.label
                                          }
                                        },
                                        [
                                          _c("BlTextBody2", {
                                            staticClass:
                                              "flex-shrink-0 truncate",
                                            attrs: { text: item.label }
                                          })
                                        ],
                                        1
                                      )
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex flex-col gap-1" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex items-center flex-shrink-0 w-full gap-3 px-2 py-2 truncate transition-all duration-300 rounded cursor-pointer hover:bg-hover-state",
                                  attrs: { title: "Sign Out" },
                                  on: { click: _vm.signOut }
                                },
                                [
                                  _c("BlTextBody2", {
                                    staticClass:
                                      "flex-shrink-0 truncate text-error-400",
                                    attrs: { text: "Sign Out" }
                                  })
                                ],
                                1
                              )
                            ])
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61dd7a3d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61dd7a3d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = null
// module chunks = 